import { Card, CardContent, CardHeader } from "@mui/material";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import dayjs from "dayjs";
import { MonthlySale, useMonthlySales } from "../../services/useMonthlySales";

export default function MonthlySalesArea() {
  const { data = [], isLoading } = useMonthlySales({
    year: new Date().getFullYear(),
  });
  const chartData = data.map((d: MonthlySale) => ({
    ...d,
    monthLabel: dayjs(d.month).format("MMM"),
  }));

  return (
    <Card sx={{ height: 400 }}>
      <CardHeader title="Faturamento mensal (acumulado)" />
      <CardContent sx={{ height: "320px" }}>
        {isLoading ? (
          "Carregando..."
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="monthLabel" />
              <YAxis />
              <Tooltip
                formatter={(v: string) => `R$ ${Number(v).toFixed(2)}`}
              />
              <Area
                type="monotone"
                dataKey={(row) => Number(row.total_gross)}
                name="Faturamento (R$)"
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
